module.exports = __webpack_public_path__ + "static/img/gm_benefit01.d884db03.png";